"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  ALL: null,
  EQ: null,
  CONTAINS: null,
  CONTAINS_ANY: null,
  LT: null,
  GT: null,
  STR_STARTS_WITH: null
});

exports.default = _default;
module.exports = exports.default;